const toastState = {
  container: null
}

function ensureToastContainer() {
  if (toastState.container) {
    return toastState.container
  }

  const container = document.createElement('div')
  container.className = 'hf-toast-stack'
  document.body.appendChild(container)
  toastState.container = container
  return container
}

export function toast(options = {}) {
  const container = ensureToastContainer()
  const type = options.type || 'info'
  const title = options.title || ''
  const message = options.message || ''
  const item = document.createElement('div')
  item.className = `hf-toast hf-toast--${type}`
  item.innerHTML = `
    <div class="hf-toast__dot"></div>
    <div>
      ${title ? `<div class="hf-toast__title">${title}</div>` : ''}
      ${message ? `<div class="hf-toast__message">${message}</div>` : ''}
    </div>
  `

  container.appendChild(item)
  window.setTimeout(() => item.classList.add('is-visible'), 10)
  window.setTimeout(() => {
    item.classList.remove('is-visible')
    window.setTimeout(() => item.remove(), 220)
  }, options.duration || 2600)
}

export function confirmDialog(message) {
  return Promise.resolve(window.confirm(message))
}

export function installUi(Vue) {
  Vue.prototype.$toast = toast
  Vue.prototype.$message = {
    success(message) {
      toast({ type: 'success', message })
    },
    warning(message) {
      toast({ type: 'warning', message })
    },
    error(message) {
      toast({ type: 'error', message })
    },
    info(message) {
      toast({ type: 'info', message })
    }
  }
  Vue.prototype.$notify = function notify(options) {
    toast(options)
  }
  Vue.prototype.$notify.error = function notifyError(options) {
    toast({ ...options, type: 'error' })
  }
  Vue.prototype.$confirmDialog = confirmDialog
}
